import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BankStatementRuleConditionKindEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.condition.kind.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { BankStatementRuleConditionKindNamePipe } from '@zaoblako/web/shared/pipes/bank-statement-rule-condition-kind-name.pipe';

@Component({
  selector: 'crm-bank-statement-rule-condition-kind-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, BankStatementRuleConditionKindNamePipe],
  templateUrl: './bank-statement-rule-condition-kind-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankStatementRuleConditionKindSingleSelectComponent {
  @Input() public kind: BankStatementRuleConditionKindEnum;
  @Output() public kindChange = new EventEmitter<BankStatementRuleConditionKindEnum>();

  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public appendTo: any;

  public options = Object.values(BankStatementRuleConditionKindEnum);
}
